/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ITableData } from './table.data';
import { ITableProps } from './table.props.autogenerated';

export interface ITableViewProps extends ITableProps<ITableData> {
    rows: React.ReactNode[];
    rowsList: IModuleProps;
    tableRow: INodeProps;
}

/**
 *
 * Table component
 * @extends {React.PureComponent<ITableProps<ITableData>>}
 */
class Table extends React.PureComponent<ITableProps<ITableData>> {

    public render(): JSX.Element | null {

        const viewProps= {
            ...this.props,
            rows: this.props.slots.content,
            rowsList: {
                moduleProps: this.props,
                className: 'rowslist',
                tag:'table'
            },
            tableRow: {
                className: 'tablerow',
                tag:'tr'
            }
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Table;
